import { Injectable, inject } from '@angular/core';
import { select, Store, Action } from '@ngrx/store';

import * as AdministratorActions from './administrator.actions';
import * as AdministratorFeature from './administrator.reducer';
import * as AdministratorSelectors from './administrator.selectors';

@Injectable()
export class AdministratorFacade {
  private readonly store = inject(Store);

  userLoginLogsList$ = this.store.pipe(select(AdministratorSelectors.GetUserLoginLogsList));
  loginLogsHistoryList$ = this.store.pipe(
    select(AdministratorSelectors.GetUserLoginLogsHistoryList)
  );
  adminOrganizatioList$ = this.store.pipe(select(AdministratorSelectors.GetAdminOrganizationList));
  adminOrganizatioModalList$ = this.store.pipe(
    select(AdministratorSelectors.GetAdminOrganizationModalList)
  );
  conversionList$ = this.store.pipe(select(AdministratorSelectors.GetConversionList));
  adminRecycleMaterialList$ = this.store.pipe(select(AdministratorSelectors.GetAdminRecycledList));
  adminMaterialList$ = this.store.pipe(select(AdministratorSelectors.GetAdminMaterialList));
  adminIngredientsList$ = this.store.pipe(select(AdministratorSelectors.GetAdminIngredientsList));
  areaBasedConversion$ = this.store.pipe(select(AdministratorSelectors.GetAreaBasedConversionList));
  getEnergyandAncillaryList$ = this.store.pipe(
    select(AdministratorSelectors.GetEnergyandAncillaryList)
  );
  getTransport$ = this.store.pipe(select(AdministratorSelectors.GetTransportList));
  processingCustomConversion$ = this.store.pipe(
    select(AdministratorSelectors.GetProcessingCustomConversionList)
  );
  processingStorageList$ = this.store.pipe(select(AdministratorSelectors.GetstorageList));
  processingWasteList$ = this.store.pipe(select(AdministratorSelectors.GetWasteList));
  refrigeratedTruckList$ = this.store.pipe(select(AdministratorSelectors.GetRefrigeratedTruck));
  processingCustomTruckList$ = this.store.pipe(
    select(AdministratorSelectors.GetProcessingCustomTruck)
  );
  otherDataMaterialList$ = this.store.pipe(select(AdministratorSelectors.GetOtherDataMaterialList));
  otherDataCircularEconomyParameterList$ = this.store.pipe(
    select(AdministratorSelectors.GetOtherDataCircularEconomyParameterList)
  );
  otherDataPalletTypeList$ = this.store.pipe(
    select(AdministratorSelectors.GetOtherDataPalletTypeList)
  );
  otherDataProjectStatusList$ = this.store.pipe(
    select(AdministratorSelectors.GetOtherDataProjectStatusList)
  );
  otherDataScenarioStatusList$ = this.store.pipe(
    select(AdministratorSelectors.GetOtherDataScenarioStatusList)
  );
  otherDataEquivalancyUnitsList$ = this.store.pipe(
    select(AdministratorSelectors.GetOtherDataEquivalancyUnitsList)
  );
  conversionMappingList$ = this.store.pipe(select(AdministratorSelectors.GetConversionMappingList));
  recycledContentList$ = this.store.pipe(select(AdministratorSelectors.GetRecycledContentList));
  otherDataCountryIndetifiersList$ = this.store.pipe(
    select(AdministratorSelectors.GetOtherDataCountryIndetifiersList)
  );
  eolGridData$ = this.store.pipe(select(AdministratorSelectors.GetEolList));
  productPackagingData$ = this.store.pipe(
    select(AdministratorSelectors.GetProductPackagingRatioList)
  );
  miscSimulationList$ = this.store.pipe(select(AdministratorSelectors.GetMiscSimulationList));
  logEntriesData$ = this.store.pipe(select(AdministratorSelectors.GetLogEntries));

  countryList$ = this.store.pipe(select(AdministratorSelectors.GetCountryList));
  stateList$ = this.store.pipe(select(AdministratorSelectors.GetStateList));
  cityList$ = this.store.pipe(select(AdministratorSelectors.GetCityList));
  importList$ = this.store.pipe(select(AdministratorSelectors.GetImportList));
  newsList$ = this.store.pipe(select(AdministratorSelectors.GetNewsList));
  rolesList$ = this.store.pipe(select(AdministratorSelectors.GetRolesList));
  stateListById$ = this.store.pipe(select(AdministratorSelectors.GetStateListById));

  clearAdminOrganization() {
    this.store.dispatch(AdministratorActions.clearAdminOrganization());
  }

  GetUserLoginLogs(payload: any) {
    this.store.dispatch(AdministratorActions.getAllLoginLogs({ usersLoginLogsPayload: payload }));
  }

  GetUserLoginLogsHistoryList(payload: any, userId: any) {
    this.store.dispatch(
      AdministratorActions.getAllLoginLogsHistory({
        usersLoginLogsHistoryPayload: payload,
        userId: userId,
      })
    );
  }

  openAddEditLoginLogsModal(loginLogsId: any, columnData?: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openLoginLogsModal({
        loginLogsId: loginLogsId,
        actionLabel: actionLabel,
        columnData: columnData,
      })
    );
  }

  GetAdminOrganizationData(payload: any) {
    this.store.dispatch(
      AdministratorActions.getAdminOrganizationData({ adminOrganizationPayload: payload })
    );
  }

  openAddEditAdminOrganizationModal(organizationId: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditAdminOrganizationModal({
        organizationId: organizationId,
        actionLabel: actionLabel,
      })
    );
  }

  addEditAdminOrganization(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditAdminOrganization({ adminOrganization: payload })
    );
  }

  deleteAdminOrganization(organizationId: any) {
    this.store.dispatch(
      AdministratorActions.deleteAdminOrganizationData({ organizationId: organizationId })
    );
  }

  inlineDataEditForAdminOrganization(adminOrganization: any) {
    this.store.dispatch(
      AdministratorActions.inlineDataEditForAdminOrganization({
        adminOrganization: adminOrganization,
      })
    );
  }

  deleteOrganizationAction(action: any, customType: any, pathName: any) {
    this.store.dispatch(AdministratorActions.deleteOrganization({ action, customType, pathName }));
  }

  deleteOrganizationData(payload: any, pathName?: any, customType?: any) {
    this.store.dispatch(
      AdministratorActions.deleteOrganizationData({ payload, pathName, customType })
    );
  }

  GetConversionData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getConversionList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditConversionModal(
    organizationId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any,
    modalName?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditConversionModal({
        organizationId: organizationId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
        modalName: modalName,
      })
    );
  }

  addEditProcessingConversion(payload: any) {
    this.store.dispatch(AdministratorActions.addEditProcessingConversion({ conversion: payload }));
  }

  getRecycledList(payload: any) {
    this.store.dispatch(
      AdministratorActions.getRecycledMaterialList({ recycledMaterialPayload: payload })
    );
  }

  GetMaterialForAdmin(payload: any) {
    this.store.dispatch(AdministratorActions.getMaterialList({ materialsPayload: payload }));
  }

  getIngredientsList(payload: any) {
    this.store.dispatch(AdministratorActions.getIngredientsList({ ingredientsPayload: payload }));
  }

  openAddEditAdminMaterialModal(id: any, regionId: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditAdminMaterialsModal({
        id: id,
        regionId: regionId,
        actionLabel: actionLabel,
      })
    );
  }

  addEditAdminMaterial(payload: any) {
    this.store.dispatch(AdministratorActions.addEditAdminMaterial({ adminMaterial: payload }));
  }

  openAddEditAdminIngredientModal(id: any, regionId: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditAdminIngredientsModal({
        id: id,
        regionId: regionId,
        actionLabel: actionLabel,
      })
    );
  }

  addEditAdminIngredient(payload: any) {
    this.store.dispatch(AdministratorActions.addEditAdminIngredients({ adminIngredient: payload }));
  }

  openAddEditAdminRecycleMaterialModal(id: any, regionId: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditAdminRecycledModal({
        id: id,
        regionId: regionId,
        actionLabel: actionLabel,
      })
    );
  }

  addEditAdminRecycleMaterial(payload: any) {
    this.store.dispatch(AdministratorActions.addEditAdminRecycled({ adminRecycled: payload }));
  }

  GetAreaBasedConversionData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getAreaBasedConversionList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditAreaBasedConversionModal(
    organizationId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditAreaBasedConversionModal({
        organizationId: organizationId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  GetEnergyandAncillaryData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getEnergyandAncillaryList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditEnergyAncillaryModal(
    energyProcessId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditEnergyandAncillaryModal({
        energyProcessId: energyProcessId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditEnergyAncillary(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditEnergyandAncillary({ energyAncillary: payload })
    );
  }

  addEditAreaBasedConversion(payload: any) {
    this.store.dispatch(AdministratorActions.addEditAreaBasedConversion({ conversion: payload }));
  }

  GetTransportData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getTransportList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditTransportModal(
    transportModeId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditTransportModal({
        transportModeId: transportModeId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditTrasnport(payload: any) {
    this.store.dispatch(AdministratorActions.addEditTransport({ transport: payload }));
  }

  GetProcessingCustomConversionData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getProcessingCustomConversionList({
        payload: payload,
        pathName: pathName,
      })
    );
  }

  openAddEditProcessingCustomConversionModal(
    energyProcessId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditProcessingCustomConversionModal({
        energyProcessId: energyProcessId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditProcessingCustomConversion(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditProcessingCustomConversion({
        processingCustomConversion: payload,
      })
    );
  }

  GetStorageData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getStorageList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditStorageModal(storageId: any, actionLabel?: any, pathName?: any, regionId?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditStorageModal({
        storageId: storageId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditStorage(payload: any) {
    this.store.dispatch(AdministratorActions.addEditStorage({ storage: payload }));
  }
  GetWasteData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getWasteList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditWasteModal(wasteId: any, actionLabel?: any, pathName?: any, regionId?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditWasteModal({
        wasteId: wasteId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditWaste(payload: any) {
    this.store.dispatch(AdministratorActions.addEditWaste({ waste: payload }));
  }

  getRefrigeratedTruckList(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getRefrigeratedTruckList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditRefrigeratedTruckModal(id: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditRefrigeratedTruckModal({
        id: id,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditRefrigeratedTruck(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditRefrigeratedTruck({ refrigeratedTruck: payload })
    );
  }

  getProcessingCustomTruckList(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getProcessingCustomTruckList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditProcessingCustomTruckModal(truckId: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditProcessingCustomTruckModal({
        truckId: truckId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditProcessingCustomTruck(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditProcessingCustomTruck({ processingCustomTruck: payload })
    );
  }

  getEolList(payload: any) {
    this.store.dispatch(AdministratorActions.getEolList({ eolPayload: payload }));
  }

  openAddEditEolModal(
    id: any,
    regionId: any,
    actionLabel?: any,
    pathName?: any,
    endPoint?: any,
    addEditEndpoint?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditEolModal({
        id: id,
        regionId: regionId,
        actionLabel: actionLabel,
        pathName: pathName,
        endPoint: endPoint,
        addEditEndpoint: addEditEndpoint,
      })
    );
  }

  addEditEol(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.addEditEol({ eolPayload: payload, pathName: pathName })
    );
  }

  deleteEolDataSuccess(deleteEolMsg: any) {
    this.store.dispatch(AdministratorActions.deleteEol({ successMsg: deleteEolMsg }));
  }

  deleteRecycledContentSuccess(deleteEolMsg: any) {
    this.store.dispatch(AdministratorActions.deleteRecycledContent({ successMsg: deleteEolMsg }));
  }

  getOtherDataMaterialList(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataMaterialList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditOtherDataMaterialModal(materialId: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditOtherDataMaterialModal({
        materialId: materialId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditOtherDataMaterial(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataMaterial({ otherMaterialPayload: payload })
    );
  }

  getOtherDataCircularEconomyParameterList(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataCircularEconomyParameterList({
        payload: payload,
        pathName: pathName,
      })
    );
  }

  openAddEditCircularEconomyParameterModal(materialId: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditCircularEconomyParameterModal({
        materialId: materialId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditOtherDataCircularEconomyParameter(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataCircularEconomyParameter({
        otherCircularEconomyParameterPayload: payload,
      })
    );
  }

  getOtherPalletType(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataPalletTypeList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditPalletTypeModal(id: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditPalletTypeModal({
        id: id,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditOtherDataPalletType(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataPalletType({ palletTypePayload: payload })
    );
  }

  getOtherProjectStatus(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataProjectstatusList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditProjectStatusModal(id: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditProjectstatusModal({
        id: id,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditOtherDataProjectStatus(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataProjectStatus({ projectStatusPayload: payload })
    );
  }

  getOtherScenarioStatus(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataScenarioStatusList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditScenarioStatusModal(id: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditScenarioStatusModal({
        id: id,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditOtherDataScenarioStatus(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataScenarioStatus({ scenarioStatusPayload: payload })
    );
  }

  getOtherDataEquivalancyUnitsList(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataEquivalancyUnitsList({
        payload: payload,
        pathName: pathName,
      })
    );
  }

  openAddEditEquivalancyUnitsModal(actionLabel: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditEquivalancyUnitsModal({ actionLabel: actionLabel })
    );
  }

  addEditOtherDataEquivalancyUnits(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataEquivalancyUnits({ equivalancyUnitsPayload: payload })
    );
  }
  getConversionMappingList(payload: any) {
    this.store.dispatch(AdministratorActions.getConversionMappingList({ payload: payload }));
  }

  openAddEditConversionMappingModal(
    id: any,
    conversionProcessId: any,
    actionLabel?: any,
    pathName?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditConversionMappingModal({
        id: id,
        conversionProcessId: conversionProcessId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditConversionMapping(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditConversionMapping({ conversionMappingPayload: payload })
    );
  }

  deleteConversionMapping(deleteEolMsg: any) {
    this.store.dispatch(AdministratorActions.deleteConversionMapping({ successMsg: deleteEolMsg }));
  }

  GetRecycledContent(payload: any) {
    this.store.dispatch(AdministratorActions.getRecycledContentList({ payload: payload }));
  }

  openAddEditRecycledContentModal(id: any, regionId: any, actionLabel?: any, pathName?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditRecycledContentModal({
        id: id,
        regionId: regionId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditRecycledContent(payload: any) {
    this.store.dispatch(AdministratorActions.addEditRecycledContent({ recycledPayload: payload }));
  }

  deleteRecycledContent(deleteMsg: any) {
    this.store.dispatch(AdministratorActions.deleteRecycledContent({ successMsg: deleteMsg }));
  }

  getOtherDataCountryIndetifiersList(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getOtherDataCountryIndetifiersList({
        payload: payload,
        pathName: pathName,
      })
    );
  }

  openAddEditCountryIndetifiersModal(
    countryIdentifierId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditCountryIndetifiersModal({
        countryIdentifierId: countryIdentifierId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditOtherDataCountryIndetifiers(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditOtherDataCountryIndetifiers({
        countryIndetifiersPayload: payload,
      })
    );
  }

  getProductPackageRationList(payload: any) {
    this.store.dispatch(AdministratorActions.getProductPackageRatioList({ payload: payload }));
  }

  openAddEditProductPackageRatioModal(
    sectorIdentifierId: any,
    regionId: any,
    actionLabel?: any,
    pathName?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditProductPackageRatioModal({
        sectorIdentifierId: sectorIdentifierId,
        regionId: regionId,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  addEditProductPackageRatio(payload: any) {
    this.store.dispatch(
      AdministratorActions.addEditProductPackageRatio({ productPackageRatioPayload: payload })
    );
  }

  GetMiscSimulationData(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getMiscSimulationList({ payload: payload, pathName: pathName })
    );
  }

  openAddEditMiscSimulationModal(
    energyprocessId: any,
    actionLabel?: any,
    pathName?: any,
    regionId?: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddMiscSimulationModal({
        energyprocessId: energyprocessId,
        actionLabel: actionLabel,
        pathName: pathName,
        regionId: regionId,
      })
    );
  }

  addEditMiscSimulation(payload: any) {
    this.store.dispatch(AdministratorActions.addEditMiscSimulation({ miscSimulation: payload }));
  }
  GetLogEntries(payload: any, pathName: any) {
    this.store.dispatch(
      AdministratorActions.getLogEntriesList({ payload: payload, pathName: pathName })
    );
  }
  openAddEditlogEntryModal(
    id: any,
    primaryId: any,
    tableName: any,
    actionLabel: any,
    pathName: any
  ) {
    this.store.dispatch(
      AdministratorActions.openAddEditlogEntryModal({
        id: id,
        primaryId: primaryId,
        tableName: tableName,
        actionLabel: actionLabel,
        pathName: pathName,
      })
    );
  }

  getCountryContent(payload: any) {
    this.store.dispatch(AdministratorActions.getAdminCountryList({ payload: payload }));
  }

  addEditCountry(payload: any) {
    this.store.dispatch(AdministratorActions.addEditCountry({ countryPayload: payload }));
  }

  openAddEditCountryModal(id: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddCountryModal({ id: id, actionLabel: actionLabel })
    );
  }

  openAddEditStateModal(id: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddStateModal({ id: id, actionLabel: actionLabel })
    );
  }

  addEditState(payload: any) {
    this.store.dispatch(AdministratorActions.addEditState({ statePayload: payload }));
  }

  getStateContent(payload: any) {
    this.store.dispatch(AdministratorActions.getAdminStateList({ payload: payload }));
  }

  getCityContent(payload: any) {
    this.store.dispatch(AdministratorActions.getAdminCityList({ payload: payload }));
  }

  openAddEditCityModal(id: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddCityModal({ id: id, actionLabel: actionLabel })
    );
  }

  addEditCity(payload: any) {
    this.store.dispatch(AdministratorActions.addEditCity({ cityPayload: payload }));
  }

  getImportContent(payload: any) {
    this.store.dispatch(AdministratorActions.getAdminImportList({ payload: payload }));
  }

  getNewsContent(payload: any) {
    this.store.dispatch(AdministratorActions.getAdminNewsList({ payload: payload }));
  }

  addEditNewsDetails(payload: any) {
    this.store.dispatch(AdministratorActions.addEditNews({ newsPayload: payload }));
  }

  openAddEditNewsModal(id: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddEditNewsModal({ id: id, actionLabel: actionLabel })
    );
  }

  getRolesContent(payload: any) {
    this.store.dispatch(AdministratorActions.getAdminRolesList({ payload: payload }));
  }

  openAddRoleModal(id: any, actionLabel?: any) {
    this.store.dispatch(
      AdministratorActions.openAddRolesModal({ id: id, actionLabel: actionLabel })
    );
  }

  addRoleModal(payload: any) {
    this.store.dispatch(AdministratorActions.addRole({ rolePayload: payload }));
  }

  openImportModal(id: any, actionLabel?: any) {
    this.store.dispatch(AdministratorActions.openImportModal({ id: id, actionLabel: actionLabel }));
  }

  uploadImportFile(payload: any) {
    this.store.dispatch(AdministratorActions.importFile({ importPayload: payload }));
  }

  getStateForAddCity(payload: any) {
    this.store.dispatch(AdministratorActions.getStateForCity({ id: payload }));
  }
}
